/**
 * @fileoverview Agent definition for plot-thread-extractor-v1.
 *
 * This agent analyzes full source text to extract plot threads —
 * lightweight narrative segments tracking subplots, minor character arcs,
 * and thematic explorations with driving questions.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-thread-extractor-v1',
  kind: 'primitive',
  name: 'Plot Thread Extractor',
  description: 'Extracts plot threads (subplots, mysteries, thematic threads) with driving questions from source text.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'experimental',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['use-plot-thread-extractor-v1'],
    usedInComposites: [],
    relatedAgents: [
      'storyline-extraction-pipeline-v1',
      'character-arc-extractor-v3',
    ],
  },
};
